import styled from "styled-components";
import { IoClose } from "react-icons/io5";

export const ModalFormContent = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  position: relative;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    padding: 0;
    gap: 1rem;
  }
`;

export const HeaderContainer = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors["gray-100"]};
  position: relative;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    min-height: 1.5rem;
    display: flex;
    padding: 0 0 0.75rem 0;
  }
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.SM};
  font-weight: ${({ theme }) => theme.fontWeight.Semibold};
  font-family: ${({ theme }) => theme.fontFamily.Roboto};
  color: ${({ theme }) => theme.colors["gray-850"]};

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const ModalAlign = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.75rem;
  align-items: start;

  div.marginSize {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    width: 100%;
    flex-direction: column;
    gap: 1rem;

    button {
      width: 100%;
    }
  }
`;

export const InputTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  font-weight: ${(props) => props.theme.fontWeight.Regular};
  font-family: ${(props) => props.theme.fontFamily.Roboto};
  color: ${(props) => props.theme.colors.black};

  .required {
    color: ${(props) => props.theme.colors["red-900"]};
    margin-left: 0.375rem;
  }
`;

export const SelectTitle = styled.span`
  font-size: ${(props) => props.theme.fontSize.XXXS};
  font-weight: ${(props) => props.theme.fontWeight.Regular};
  font-family: ${(props) => props.theme.fontFamily.Roboto};
  color: ${(props) => props.theme.colors["black-925"]};
`;

export const GridSpacer = styled.div`
  @media (max-width: ${({ theme }) => theme.responsiveDesign.sm}) {
    display: none;
  }
`;

export const GridItemStart = styled.div`
  justify-self: start;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors["gray-850"]};
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;
